import React, { useEffect, useState } from "react";

function Hours() {
    const [hours, setHours] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchHours = async () => {
            try {
                const response = await fetch("https://northshoresoapworks.com/get_hours.php");
                const result = await response.json();

                if (!result.status) {
                    // API returned a failure
                    throw new Error(result.message || "Failed to load hours.");
                }

                setHours(result.data);
            } catch (err) {
                setError(err.message || "An unexpected error occurred.");
            } finally {
                setLoading(false);
            }
        };

        fetchHours();
    }, []);

    return (
        <main>
            <section className="aboutus-wrapper">
                <div className="logo-container">
                    <img
                        loading="lazy"
                        src="https://northshoresoapworks.com/images/bird.png"
                        className="bird-img bird-1"
                        alt=""
                    />
                    <img
                        loading="lazy"
                        src="https://northshoresoapworks.com/images/logo.png"
                        className="aboutus-logo"
                        alt=""
                    />
                    <img
                        loading="lazy"
                        src="https://northshoresoapworks.com/images/bird.png"
                        className="bird-img"
                        alt=""
                    />
                </div>
            </section>

            <h1 className="text-center mb-4 fs-1">Hours & Location</h1>
            <hr />

            <section className="map-and-hours">
                <div>
                    <iframe
                        className="map"
                        title="map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2928.0533553502764!2d-80.20707328712163!3d42.78722190788566!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882c5373d917aff9%3A0x6d596df7a4f1cf84!2sNorth%20Shore%20Soapworks%20(previously%20Cottage%20North%20Soapworks)!5e0!3m2!1sen!2sca!4v1767748206536!5m2!1sen!2sca"
                        width="100%"
                        height="600"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>

                <div className="hours">
                    <h2>Hours Of Operation</h2>
                    <hr />

                    {/* Loading */}
                    {loading && (
                        <div className="text-center my-4">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}

                    {/* Error */}
                    {!loading && error && (
                        <div className="alert alert-danger">
                            {error}
                        </div>
                    )}

                    {/* Success */}
                    {!loading && hours && (
                        <>
                            Monday: {hours.monday} <br />
                            Tuesday: {hours.tuesday} <br />
                            Wednesday: {hours.wednesday} <br />
                            Thursday: {hours.thursday} <br />
                            Friday: {hours.friday} <br />
                            Saturday: {hours.saturday} <br />
                            Sunday & Holidays: {hours.sunday} <br />
                        </>
                    )}
                </div>
            </section>
        </main>
    );
}

export default Hours;
